export const ONBOARDING_STEPS = {
    START: 'START',
    REQUEST_QUOTE: 'REQUEST_QUOTE',
    ADD_MAIL: 'ADD_MAIL',
    CONFIRM_MAIL: 'CONFIRM_MAIL',
    CONFIRM_SELECTION: 'CONFIRM_SELECTION',
    PAYMENT: 'PAYMENT',
    CANCEL: 'CANCEL',
};
